var _circle, _g, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#E5F4F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6584_8401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5555 32.6619L37.6555 25.8259C37.0986 23.8233 35.8882 22.0642 34.2168 20.8284C32.5454 19.5926 30.5089 18.9509 28.4309 19.0054C26.353 19.0599 24.3529 19.8074 22.7485 21.1291C21.1442 22.4508 20.0277 24.2708 19.5765 26.2999L18.1055 32.9149C17.943 33.6459 17.9467 34.404 18.1165 35.1333C18.2862 35.8625 18.6175 36.5444 19.0861 37.1285C19.5546 37.7126 20.1483 38.184 20.8234 38.5079C21.4985 38.8318 22.2377 39 22.9865 38.9999H24.1005C24.33 40.1302 24.9432 41.1464 25.8362 41.8763C26.7292 42.6062 27.8471 43.0049 29.0005 43.0049C30.1538 43.0049 31.2717 42.6062 32.1647 41.8763C33.0577 41.1464 33.671 40.1302 33.9005 38.9999H34.7385C35.5093 39 36.2697 38.8218 36.9602 38.4794C37.6508 38.1369 38.2528 37.6394 38.7193 37.0258C39.1858 36.4122 39.504 35.699 39.6493 34.942C39.7945 34.185 39.7627 33.4046 39.5565 32.6619H39.5555ZM29.0005 40.9999C28.3822 40.9974 27.7798 40.8039 27.2758 40.4458C26.7717 40.0878 26.3906 39.5828 26.1845 38.9999H31.8165C31.6104 39.5828 31.2292 40.0878 30.7252 40.4458C30.2211 40.8039 29.6187 40.9974 29.0005 40.9999ZM37.1265 35.8149C36.8478 36.1846 36.4868 36.4842 36.0721 36.6899C35.6574 36.8956 35.2004 37.0018 34.7375 36.9999H22.9865C22.5373 36.9999 22.0938 36.8989 21.6888 36.7045C21.2838 36.5101 20.9277 36.2273 20.6466 35.8768C20.3656 35.5264 20.1668 35.1173 20.065 34.6798C19.9632 34.2423 19.961 33.7874 20.0585 33.3489L21.5285 26.7329C21.8828 25.1391 22.7598 23.7095 24.0199 22.6714C25.2801 21.6332 26.8511 21.0461 28.4832 21.0033C30.1154 20.9606 31.715 21.4647 33.0278 22.4354C34.3406 23.4062 35.2912 24.7879 35.7285 26.3609L37.6285 33.1969C37.754 33.6423 37.774 34.1108 37.6869 34.5653C37.5997 35.0197 37.4079 35.4476 37.1265 35.8149Z",
    fill: "#1B9075"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 18,
    r: 2,
    stroke: "#1B9075",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6584_8401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(17 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.74e0c976a7e6ccdd39f9a2c19abfbb96.svg";
export { ForwardRef as ReactComponent };